import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

/** Parse DD/MM/YYYY API strings to a UTC-midnight Date (matches CustomDatePicker storage). */
export function parseApiDateToUtcDate(value) {
    if (!value || value === 'null') return null;

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()));
    }

    const s = String(value).split(' ')[0].trim();
    const parsed = dayjs(s, 'DD/MM/YYYY', true);
    if (parsed.isValid()) {
        return new Date(Date.UTC(parsed.year(), parsed.month(), parsed.date()));
    }

    const isoParsed = dayjs(s);
    if (isoParsed.isValid()) {
        return new Date(Date.UTC(isoParsed.year(), isoParsed.month(), isoParsed.date()));
    }

    return null;
}

export function parseApiDateToUtcIso(value) {
    const date = parseApiDateToUtcDate(value);
    return date ? date.toISOString() : null;
}

export function formatApiDateForDisplay(value) {
    const date = parseApiDateToUtcDate(value);
    return date ? dayjs.utc(date).format('DD/MM/YYYY') : '—';
}
